import * as d3 from "d3";
import {colonAnnotation, createTooltip, fw_progressive_1way, inrFormatter, responsivefy} from '../functions'

export default function (chart, divId, vizName,resData, filterParam) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName,filterParam)

    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId).append('svg')
        .attr('width', chart.width)
        .attr('height', chart.height)
        .call(responsivefy)
        .append('g')

    var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way);

    var treemap = d3.treemap()
        .tile(d3.treemapResquarify)
        .size([chart.width, chart.height])
        .round(true)
        .paddingInner(1)

    // axios.post(url, filterParam).then(res => {
        let data = resData
        var nest = d3.nest()
            .key((d) => {
                return d.dim1_name
            })
            .key((d) => {
                return d.dim2_name
            })
            .key((d) => {
                return d.dim3_name == null ? '' : d.dim3_name
            })
            .rollup(function (d) {
                return d3.sum(d, function (d) {
                    return d.metric1
                })
            })

        var root = d3.hierarchy({values: nest.entries(data)},
            function (d) {
                return d.values
            })
            .sum(function (d) {
                return d.value
            })
            .sort(function (a, b) {
                return b.value - a.value
            })

        treemap(root)

        var cell = svg.selectAll('g')
            .data(root.leaves())
            .enter()
            .append('g')
            .attr('transform', (d) => {
                return 'translate(' + d.x0 + ',' + d.y0 + ')'
            })

        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
        var y1tip = tooltip_class()

        y1tip.attr('class', 'd3-tip'+divId.id)
             .html((d) =>{
                   return d.parent.parent.data.key + '/' + d.parent.data.key + '/'
                          + d.data.key+ colonAnnotation+ inrFormatter(d.value)
            })

        cell.call(y1tip)*/

        const tooltip = createTooltip(divId);


        cell.append('rect')
            .attr('id', (d) => {
                return d.data.key
            })
            .attr('width', (d) => {
                return d.x1 - d.x0
            })
            .attr('height', (d) => {
                return d.y1 - d.y0
            })
            .attr('fill', (d) => {
                return metric1ColorScale(d.parent.parent.data.key)
            })
            .on("mouseover", function(d) {
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return chart.x1MetricTooltip + colonAnnotation + d.parent.parent.data.key +
                        '<br>' + chart.x2MetricTooltip + colonAnnotation + d.parent.data.key
                        + '<br>' + chart.y1MetricTooltip + colonAnnotation + d.data.key +
                        '<br>' + chart.y2MetricTooltip + colonAnnotation + inrFormatter(d.value)
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on("mouseout", function() {
                // Hide the tooltip on mouse out
                tooltip.onMouseLeave();
            });

        cell.append('text')
            .selectAll('tspan')
            .data(function (d) {
                return d.data.key == '' ? d.parent.data.key.split(/(?=[A-Z][^A-Z])/g) : d.data.key.split(/(?=[A-Z][^A-Z])/g)
            })
            .enter()
            .append('tspan')
            .attr('x', 10)
            .attr('y', function (d, i) {
                return 20 + i * 13.5
            })
            .text(function (d) {
                return d
            })

        cell.append('text')
            .attr('x', 10)
            .attr('y', 75)
            .text(function (d) {
                return inrFormatter(d.value)
            })

    // })
}
